const numberFormatter = new Intl.NumberFormat(undefined, {
  maximumSignificantDigits: 15,
});

export function formatScalarValue(value: unknown): string {
  if (value === null || value === undefined) return '—';
  if (typeof value === 'string') return value;
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (typeof value === 'number') {
    return Number.isFinite(value) ? numberFormatter.format(value) : 'Unavailable';
  }
  return 'Unavailable';
}

export function formatScalarTitle(value: unknown): string | null {
  if (value === null || value === undefined) return null;
  if (typeof value === 'string') return value.length === 0 ? null : value;
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (typeof value === 'number' && Number.isFinite(value)) return numberFormatter.format(value);
  return null;
}
